const tagTypes = [
  "User",
  "Product",
  "AllStaff",
  "AllStaffBasic",
  "AccessList",
  "accessList",
  "users",
  "permissions",
  "userBalanceStaff",
  "Department",
  "Zone",
  "Location",
  "Shift",
  "EmployeeShiftS",
  "NormalShiftWorkingHours",
  "FixedTemplates",
  "Category",
  "Requests",
  "Activities",
  "Timekeeper",
];

export default tagTypes;
